import { DefaultError } from "../models/default-error.model";
import { AutoError } from "../models/auto-error.model";
import { ValidationErrors } from "@angular/forms";

export class ErrorHelper {

  private static autoErrors = {
    required: (fieldNameTranslation: string, errorData: any) => {
      const errorTranslation = ErrorHelper.getTranslation(
        errorData,
        "This field is required"
      );
      return new AutoError(fieldNameTranslation, errorTranslation, null);
    },
    minLength: (fieldNameTranslation: string, errorData: any) => {
      var eventValues = Object.values(errorData)
      const errorTranslation = ErrorHelper.getTranslation(
        errorData,
        "The minimum length is: " + eventValues[0].toString()
      );
      const values = ErrorHelper.getTranslationValues(errorData);
      return new AutoError(fieldNameTranslation, errorTranslation, values);
    },
    minlength: (fieldNameTranslation: string, errorData: any) => {
      var eventValues = Object.values(errorData)
      const errorTranslation = ErrorHelper.getTranslation(
        errorData,
        "The minimum length is: " + eventValues[0].toString()
      );
      const values = ErrorHelper.getTranslationValues(errorData);
      return new AutoError(fieldNameTranslation, errorTranslation, values);
    },
    maxLength: (fieldNameTranslation: string, errorData: any) => {
      var eventValues = Object.values(errorData)
      const errorTranslation = ErrorHelper.getTranslation(
        errorData,
        "The maximum length is: " + eventValues[0].toString()
      );
      const values = ErrorHelper.getTranslationValues(errorData);
      return new AutoError(fieldNameTranslation, errorTranslation, values);
    },
    maxlength: (fieldNameTranslation: string, errorData: any) => {
      var eventValues = Object.values(errorData)
      const errorTranslation = ErrorHelper.getTranslation(
        errorData,
        "The maximum length is: " + eventValues[0].toString()
      );
      const values = ErrorHelper.getTranslationValues(errorData);
      return new AutoError(fieldNameTranslation, errorTranslation, values);
    },
    pattern: (fieldNameTranslation: string, errorData: any) => {
      let errorTranslation;
      const pattern = errorData?.requiredPattern.toString();
      if (pattern === /^[a-zA-Z\s]+$/.toString()) {
        errorTranslation = "Only letters and spaces are allowed";
      } else if (pattern === /^[0-9]+$/.toString()) {
        errorTranslation = "Only numbers are allowed";
      } else if (pattern === /^[0-9]\d*$/.toString()) {
        errorTranslation = "Only numbers are allowed (no leading zeros)";
      } else if (pattern === /^\d*$/.toString()) {
        errorTranslation = "Only numbers are allowed (including empty string)";
      } else if (pattern === /^0?[0-9]+$/.toString()) {
        errorTranslation = "Only numbers are allowed";
      } else if (pattern === /^[a-zA-Z#]+(?:-[a-zA-Z#]+)*$/.toString()) {
        errorTranslation = "Only letters, hyphens, and hash tags are allowed";
      } else if (pattern === /^[a-zA-Z]+(?:-[a-zA-Z]+)*$/.toString()) {
        errorTranslation = "Only letters and hyphens are allowed";
      } else if (pattern === /^[a-zA-Z\s]+(?:-[a-zA-Z\s]+)*$/.toString()) {
        errorTranslation = "Only letters, spaces, and hyphens are allowed";
      } else if (pattern === /^[a-zA-Z\sÀ-ÿ-]+(?:-[a-zA-Z\sÀ-ÿ-]+)*$/.toString()) {
        errorTranslation = "Only letters, spaces, and accented characters are allowed";
      } else {
        errorTranslation = "Invalid format";
      }
      return new AutoError(fieldNameTranslation, errorTranslation, null);
    },
    numbersOnly: (fieldNameTranslation: string, errorData: any) => {
      const errorTranslation = ErrorHelper.getTranslation(
        errorData,
        "Only numbers are allowed"
      );
      return new AutoError(fieldNameTranslation, errorTranslation, null);
    },

    lettersOnly: (fieldNameTranslation: string, errorData: any) => {
      const errorTranslation = ErrorHelper.getTranslation(
        errorData,
        "Only letters are allowed"
      );
      return new AutoError(fieldNameTranslation, errorTranslation, null);
    },
    email: (fieldNameTranslation: any, errorData: any) => {
      // Check if errorData is true
      if (errorData) {
        const errorTranslation = ErrorHelper.getTranslation(
          errorData,
          "Please enter a valid email"
        );

        let values = ErrorHelper.getTranslationValues(errorData);
        const valuesStr = values ? String(values).trim() : ''; // Convert to string and remove whitespace

        // Regular expression for email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        // Check if the value looks like an email

        if (emailRegex.test(valuesStr)) {
          // Split the email into username and domain parts
          const [username, domain] = valuesStr.split('@');

          // Check if both username and domain parts exist
          if (!username || !domain) {
            // If either the username or domain part is missing, return an error
            return new AutoError(fieldNameTranslation, "Please enter a valid email", values);
          }

          // Check if the domain contains at least one dot (.) followed by at least two characters
          const domainParts = domain.split('.');
          if (domainParts.length < 2 || domainParts[domainParts.length - 1].length < 2) {
            return new AutoError(fieldNameTranslation, "Invalid email format: Domain is invalid", values);
          }

          // Check if the domain is valid
          const validTLDs = ['gov.za', 'co.za', 'co.au']; // Add more TLDs as needed
          const domainTLD = domainParts.slice(-2).join('.');
          if (!validTLDs.includes(domainTLD)) {
            return new AutoError(fieldNameTranslation, "Invalid email format: Unsupported domain", values);
          }

          // Email format seems valid
          return null; // No error message needed, validation passed
        } else {
          // If the value doesn't match the email format, return an error object
          return new AutoError(fieldNameTranslation, "Please enter a valid email", values);
        }
      } else {
        // If errorData is not true, return null indicating validation passed
        return null;
      }
    }

  };

  private static getTranslation(errorData: any, defaultTranslation: string) {
    return errorData.message ? errorData.message : defaultTranslation;
  }

  private static getTranslationValues(errorData: any) {

    if (errorData.refValues && errorData.refValues.length > 1) {
      return { length: errorData.refValues[1] };
    }
    return null;
  }

  public static getError(
    fieldNameTranslation: string,
    validationErrors: ValidationErrors
  ): AutoError | DefaultError {

    const firstKey = Object.keys(validationErrors)[0];
    if (ErrorHelper.autoErrors[firstKey]) {
      return ErrorHelper.autoErrors[firstKey].call(
        this,
        fieldNameTranslation,
        validationErrors[firstKey]
      );
    } else if (
      validationErrors[firstKey] instanceof AutoError ||
      validationErrors[firstKey] instanceof DefaultError
    ) {
      return validationErrors[firstKey];
    } else {
      throw Error("Validation error without auto or default message set!");
    }
  }
}
